import script from "./single-image-processing.vue?vue&type=script&lang=ts&setup=true"
export * from "./single-image-processing.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__